document.addEventListener('DOMContentLoaded', () => {
  // Function to add the selected-variant class to selected variant labels
  function markSelectedVariants() {
    // Get all checked input-radio elements
    const checkedRadios = document.querySelectorAll('input.input-radio:checked');
    
    // For each checked radio, add selected-variant class to its label
    checkedRadios.forEach(radio => {
      // Find the associated label either by for attribute or as next sibling
      const label = document.querySelector(`label[for="${radio.id}"]`) || radio.nextElementSibling;
      
      if (label && label.classList.contains('color-watches')) {
        label.classList.add('selected-variant');
      }
    });
  }

  // Run on page load
  markSelectedVariants();

  // Also run when radio inputs change
  document.addEventListener('change', event => {
    if (event.target.classList.contains('input-radio')) {
      // First, remove the class from all variant labels
      document.querySelectorAll('label.color-watches').forEach(label => {
        label.classList.remove('selected-variant');
      });
      
      // Then add it to the selected one
      setTimeout(markSelectedVariants, 0);
    }
  });

  // Check for mutations affecting the variant selection
  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'checked') {
        markSelectedVariants();
      } else if (mutation.type === 'childList' && [...mutation.addedNodes].some(node => node.nodeName === 'INPUT')) {
        markSelectedVariants();
      }
    }
  });

  // Observe the entire document for changes to input-radio elements
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['checked'],
    childList: true,
    subtree: true
  });
});
